import styled from 'styled-components';

export const InlineAutocompleteField = styled.div`
  * {
    box-sizing: border-box;
  }
  & > * {
    width: 100%;
    & > div {
      width: 100%;
      & > div {
        &:not(.MuiChip-icon) {
          padding: 0 0 0 8px !important;
        }
      }
    }
  }

  .MuiChip-icon {
    margin-left: 4px !important;
  }
`;

export const InlineSelectField = styled.div`
  * {
    box-sizing: border-box;
  }
  & > * {
    width: 100%;
    padding: 0;
  }
`;

export const InlineDateField = styled.div`
  * {
    box-sizing: border-box;
  }
  & > * {
    width: 100%;
    & > div {
      width: 100% !important;
    }
  }
  .SingleDatePicker_picker {
    z-index: 1001;
  }
  .DateRangePickerInput {
    border: none;
    height: auto;
    padding: 6px 0;
  }
  .DateRangePickerInput__disabled {
    background: transparent !important;
  }
  .DateRangePicker_picker__directionLeft {
    right: 0;
    left: auto !important;
  }
`;

export const SectionHeader = styled.h2`
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 1em;
  font-weight: bold;

  & > * {
    margin: 0;
  }
`;

export const FieldSet = styled.fieldset`
  margin: 0 0 24px 0;
  padding: 0;
  border: none;
  max-width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: ${({ alignItems }) =>
    alignItems === 'center' ? 'center' : 'flex-start'};
  width: 100%;
  min-width: 500px;
  margin-bottom: 16px;

  & > * {
    width: calc(
      ${({ items = 1 }) => 100 / items}% -
        ${({ items = 1 }) => (16 * (items - 1)) / items}px
    );
    padding: 0;
  }
`;
